<div class="menu-content" [ngStyle]="objPosition" #tableFilter>
    <div class="filter-search-content">
      <button type="button" class="close" aria-label="Close" (click)="closeFilter()"><span aria-hidden="true">&times;</span></button>
      <div class="filter-search-body">
        <label for="email" *ngIf="searchLabel" class="search-font"><img src="assets/images/search.svg">
          {{searchLabel.title}}</label>
        <div class="form-group">
          <input type="text" autocomplete="off" [formControl]="queryField" class="form-control searchfield" placeholder="Search" id="email">
        </div>
  
        <div class="option-list-filter" [ngClass]="optionList.length < 8 ? 'setLowHeight':'' ">
          <div class="select-all">
            <input type="checkbox" class="usrcheck prt" (change)="selectDeselectAll($event)"/>
            <span class="showdect">Select All</span>
          </div>
          <div class="option-list" *ngFor="let option of optionList">
            <!-- <mat-checkbox [value]="option" class="example-margin" (change)="setSearchValue($event)">
              {{option}}
            </mat-checkbox> -->
            <input type="checkbox" [checked]="option.isSelected"  [value]="option.label" class="usrcheck prt" (change)="setSearchValue($event)" /> 
            <span class="showdect">{{option.label}}</span>
    
          </div>
        </div>
        
        <div class="footerBtnSection">
          <div class="btnitem cancelBtn">
            <button class="btn btn-close" (click)="closeFilter()">Cancel</button>
          </div>
          <div class="btnitem acceptBtn">
            <button class="btn btn-accept" (click)="searchApply()">Filter</button>
          </div>
        </div>
       
      </div>
  
    </div>
  
  </div>